import React from 'react';
import ReactDOM from 'react-dom';

const FormWidget = window.auiEmbeddableWidgets.reactComponent(
  "https://formwidget.antwerpen.be/definitions/v1/form-renderer.json",
  { React, ReactDOM },
);

export default FormWidget;
